import {Injectable} from '@angular/core';
import {EvkCreateServiceBase, EvkHttpService, MessageCrudService} from '@evomatik/evk-common';
import {Observable} from 'rxjs/internal/Observable';
import {DiligenciaTareaModel} from "../../../../../../../diligencia/models/diligencia-tarea.model";

@Injectable({
    providedIn: 'root'
})
export class SolicitarAutorizacionCreateService extends EvkCreateServiceBase<DiligenciaTareaModel> {

    constructor(public http: EvkHttpService,
                public messageCrudService: MessageCrudService) {
        super(http);
    }

    get api(): string {
        return '/seaged-diligencias-service/diligencia/solicitar';
    }

    evkOnBeforeSave(data: DiligenciaTareaModel): Observable<DiligenciaTareaModel> {
        return new Observable<DiligenciaTareaModel>(subscriber => {
            subscriber.next(data);
        });
    }

    evkOnDoneSave(response: any): void {

    }

    evkOnErrorSave(error: any): void {
    }
}
